import { APP_INITIALIZER, Inject, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { ButtonsModule } from "@progress/kendo-angular-buttons";
import { DialogsModule } from "@progress/kendo-angular-dialog";
import { DropDownsModule } from "@progress/kendo-angular-dropdowns";
import { InputsModule } from "@progress/kendo-angular-inputs";
import { MenuModule } from "@progress/kendo-angular-menu";
import { TooltipModule } from "@progress/kendo-angular-tooltip";
import { AppRoutingModule } from "./app-routing.module";

import { DialogModule } from "@digic/dialog";
import { LayoutModule } from "@progress/kendo-angular-layout";
import { NotificationModule } from "@progress/kendo-angular-notification";

import { ENVIRONMENTER as LayoutEnvironmenter, LayoutComponent, LayoutModule as dAppLayoutModule } from "@digic/layout";
import { ENVIRONMENTER as NotificationsEnvironmenter } from "@digic/notifications";
import {
  AuthenticationService,
  DefaultEmployeeService,
  DefaultLocalizationService,
  DefaultNotificationService,
  EmployeeServiceBase,
  ENVIRONMENTER,
  HealthcheckService,
  HttpErrorInterceptor,
  HttpLoaderFactory,
  initializeKeycloak,
  LocalizationServiceBase,
  NotificationServiceBase,
  SharedModule,
  WinAuthInterceptor,
} from "@digic/shared";

import { CdkTreeModule } from "@angular/cdk/tree";
import { HttpClient, HTTP_INTERCEPTORS } from "@angular/common/http";
import { ReactiveFormsModule } from "@angular/forms";
import { HostsModule } from "@digic/hosts";
import { SvgLoaderModule } from "@digic/svg-loader";
import { LoadingBarModule } from "@ngx-loading-bar/core";
import { LoadingBarHttpClientModule } from "@ngx-loading-bar/http-client";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { KeycloakService } from "keycloak-angular";
import { CONFIG_DATA } from "src/configData";
import { environment } from "src/environments/environment";
import { DashboardComponent } from "./dashboard/dashboard.component";

@NgModule({
  declarations: [DashboardComponent],
  imports: [
    BrowserModule,
    CdkTreeModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,

    //Kendo modules
    MenuModule,
    ButtonsModule,
    NotificationModule,
    InputsModule,
    TooltipModule,
    DialogsModule,
    DropDownsModule,

    DialogModule,
    LayoutModule,
    SharedModule,
    SvgLoaderModule,
    HostsModule,

    dAppLayoutModule,
    LoadingBarModule,
    LoadingBarHttpClientModule,
    TranslateModule.forRoot({
      defaultLanguage: "hu",
      useDefaultLang: true,
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    AppRoutingModule,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    { provide: NotificationServiceBase, useClass: DefaultNotificationService },
    { provide: LocalizationServiceBase, useClass: DefaultLocalizationService },
    { provide: EmployeeServiceBase, useClass: DefaultEmployeeService },
    { provide: ENVIRONMENTER, useFactory: (config) => config, deps: [CONFIG_DATA] },
    { provide: LayoutEnvironmenter, useFactory: (config) => config, deps: [CONFIG_DATA] },
    { provide: NotificationsEnvironmenter, useFactory: (config) => config, deps: [CONFIG_DATA] },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeKeycloak,
      multi: true,
      deps: [KeycloakService, AuthenticationService, HealthcheckService],
    },
  ],
  bootstrap: [LayoutComponent],
})
export class AppModule {}
